// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"02d849e3","453":"42df5f66"}[chunkId] + ".chunk.js";
};